import axios from 'axios';

export const alertService = {
    listAlerts,
	solveAlert
};

function listAlerts() {
	//console.log("alertService.listAlerts");
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/alert/", {params: {}});
}

function solveAlert(oneAlert) {
	//console.log("alertService.solveAlert: "+oneAlert);
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	let body = {oneAlert};
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/alert/"+oneAlert.id+"/solve", body, headers);
}